export const getStringRepresentation = (p, templateId = 0) => {
	if (!p) return '';
	if (typeof templateId !== 'number') templateId = parseInt(templateId);
	switch (templateId) {
		default:
		case 0:
			return `${p.vorname} ${p.zuname} (${p.persNr})`;
		case 2:
			return `${p.vorname} ${p.zuname}`;
		case 1:
			return `${p.zuname} ${p.vorname} (${p.persNr})`;
		case 3:
			return `${p.zuname} ${p.vorname}`;
	}
};

export const getHTMLRepresentation = (p, templateId = 0) => {
	if (!p) return '';
	if (typeof templateId !== 'number') templateId = parseInt(templateId);
	switch (templateId) {
		default:
		case 0:
			return `${p.vorname} ${p.zuname} <small>${p.persNr}</small>`;
		case 2:
			return `${p.vorname} ${p.zuname}`;
		case 1:
			return `${p.zuname} ${p.vorname} <small>${p.persNr}</small>`;
		case 3:
			return `${p.zuname} ${p.vorname}`;
	}
};
